export { SpaClassCard } from './SpaClassCard';
export type { SpaClassCardProps } from './SpaClassCard.types';
